exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "img[data-v-f63ba442]{max-height:200px}.view-image-icon[data-v-f63ba442]{position:absolute;width:40px;height:40px;left:0;top:0;right:0;bottom:0;margin:auto;padding:6px 9px;line-height:1.4;font-size:20px;background-color:rgba(0,0,0,.5);color:#fff;border-radius:20px;display:none;cursor:pointer}@media (max-width:575px){.btn[data-v-f63ba442]{display:block;width:100%}}", ""]);

// exports
